import { TransportMethodEnum } from 'api';
import { SelectField, SelectFieldProps } from 'form';
import { type I18nTranslateFunction, useTranslation } from 'i18n';

const getTransportMethodOptions = (t: I18nTranslateFunction<string>) => [
  {
    label: t('transportMethod.options.container20ft'),
    value: TransportMethodEnum['20FT_CONTAINER'],
  },
  {
    label: t('transportMethod.options.container40ft'),
    value: TransportMethodEnum['40FT_CONTAINER'],
  },
  {
    label: t('transportMethod.options.curtainSide'),
    value: TransportMethodEnum.CS,
  },
  {
    label: t('transportMethod.options.walkingFloor'),
    value: TransportMethodEnum.WF,
  },
  {
    label: t('transportMethod.options.boxTrailer'),
    value: TransportMethodEnum.BT,
  },
];

type TransportMethodProps = Omit<SelectFieldProps, 'options' | 'name' | 'label'>;

export const TransportMethod = ({ ...props }: TransportMethodProps) => {
  const { t } = useTranslation('orders');

  return (
    <SelectField
      label={t('transportMethod.label')}
      name="transport_method"
      options={getTransportMethodOptions(t)}
      fullWidth={true}
      infoTooltip={t('transportMethod.infoTooltip')}
      {...props}
    />
  );
};
